// @flow

import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';

import ConversationPage from './ConversationPage';
import {
  clearScribeConversationState,
  clearScribeSessionState,
  exitScribeMode,
  getTranscriptStats,
  scribeCreateTranscript,
  scribeDeselectTranscriptWord,
  setAvailableMics,
  setMicSelected,
  startRecord,
  stopRecord,
  toggleSideBar,
  updateBroadcastToZoomToken,
  updateConversationEndedStatus,
  updateFullScreen,
  updateElectronCaptionMode,
  updateIsInConversation,
  updateKeyboardInputShown,
} from '../../../actions';
import { setCCMode } from '../../../actions/cc-mode';
import { fetchAvaProfileMetrics } from '../../../actions/session';
import { setConversationStatus } from '../../../actions/rate-conversation';

const mapStateToProps = ({
  scribeTranscriptUI: { fontSize, fullScreen, electronCaptionMode },
  scribeSession: {
    branch,
    captioner,
    currentPlatform,
    displayable,
    inConferenceCall,
    intercomDisplayed,
    lightView,
    loading,
    microphoneAccess,
    needInternalAudioAccess,
    showQuickSetup,
    socketConnectionStatus,
    subscription,
  },
  scribeConversation: {
    allMicsSelected,
    availableMics,
    broadcastToZoomToken,
    conversationEnded,
    conversationEndedMessage,
    conversationEndedSuccessfully,
    conversationStarted,
    isBoosting,
    inTwilioCalls,
    isInConversation,
    lastMutationReceived,
    micIdSelected,
    muted,
    recording,
    scribe,
    speechLang,
    status,
    token,
    transcriptsCurrent,
    transcriptsFinal,
    ui: { keyboardInputShown },
  },
}) => ({
  allMicsSelected,
  availableMics,
  branch,
  broadcastToZoomToken,
  conversationEnded,
  conversationEndedMessage,
  conversationEndedSuccessfully,
  conversationStarted,
  currentPlatform,
  displayable,
  electronCaptionMode,
  fontSize,
  fullScreen,
  haveTranscripts: transcriptsCurrent.length + transcriptsFinal.length > 0,
  inConferenceCall,
  intercomDisplayed,
  inTwilioCalls,
  isBoosting,
  isInConversation,
  lastMutationReceived,
  lightView,
  loading,
  microphoneAccess,
  micIdSelected,
  muted,
  needInternalAudioAccess,
  keyboardInputShown,
  recording,
  scribe,
  showQuickSetup,
  speechLang,
  socketConnectionStatus,
  status,
  subscription,
  token,
  user: captioner,
});

const mapDispatchToProps = {
  clearScribeConversationState,
  clearScribeSessionState,
  exitScribeMode,
  fetchAvaProfileMetrics,
  getTranscriptStats,
  scribeCreateTranscript,
  scribeDeselectTranscriptWord,
  setAvailableMics,
  setCCMode,
  setConversationStatus,
  setMicSelected,
  startRecord,
  stopRecord,
  toggleSideBar,
  updateBroadcastToZoomToken,
  updateConversationEndedStatus,
  updateFullScreen,
  updateElectronCaptionMode,
  updateIsInConversation,
  updateKeyboardInputShown,
};

export default withSnackbar(connect(mapStateToProps, mapDispatchToProps)(ConversationPage));
